<template>
  <div class="attendance-report-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <div class="btn-box" style="display: flex;justify-content: flex-start;align-items: center;">
          <div style="margin-right: 10px;">考勤月份</div>
          <el-date-picker v-model="requestData.month" type="month" format='yyyy-MM' value-format="yyyy-MM" size="small" style="width: 180px" placeholder="考勤月份"></el-date-picker>
        </div>
        <button-confirm @confirm="manualGenerateReport" value="生成报表" style="margin-left: 10px" v-if="permissionCodes.indexOf('034016001') !== -1"/>
        <button-export
          style="margin-left: 10px"
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          value="导出"/>
        <el-tag type="warning">温馨提示：导出数据为所有部门员工数据</el-tag>
      </div>
    </div>
    <div class="statistical-data-line">
      <div class="statistical-data-item" v-for="item in statisticalDataList">
        <div class="statistical-data-item-num">{{item.num}}<span class="statistical-data-item-unit">{{item.unit}}</span></div>
        <div class="statistical-data-item-tip">{{item.name}}</div>
      </div>
    </div>
    <div class="search-line">
      <input-select selectTitle="部门" :selectKey="'deptCode'" selectWidth="165px" :selectData="deptList" @search="search" style="margin-right: 10px;"/>
      <div style="display: flex;justify-content: space-between;">
        <input-search placeholder="员工姓名" @search="searchKey" />
      </div>
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该排班？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/AttendancePoint'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nError, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'
  import ButtonConfirm from "../../../components/Button/ButtonConfirm";

  export default {
    components: {
      ButtonConfirm,
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb
    },
    name: 'attendance-report-manage',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧考勤',
          name: 'attendance-department-manage'
        }, {
          value: '薪酬报表'
        }],
        statisticalDataList: [
          {code: 'totalSalary', name: '薪资合计', num: '0', unit: '元'},
          {code: 'managementFee', name: '管理费', num: '0', unit: '元'},
          {code: 'tax', name: '税金', num: '0', unit: '元'},
          {code: 'totalPropertyFee', name: '物管费合计', num: '0', unit: '元'},
        ],
        exportUrl: '',
        operationArr: ['modify', 'delete'],

        tableHead: [{
          prop: 'personName',
          label: '员工姓名'
        }, {
          prop: 'deptName',
          label: '部门名称'
        }, {
          prop: 'positionName',
          label: '岗位名称'
        }, {
          prop: 'salary',
          label: '月薪资(元)'
        }, {
          prop: 'dueDays',
          label: '应出勤天数(天)'
        }, {
          prop: 'actaulDays',
          label: '实出勤天数(天)'
        }, {
          prop: 'overtime',
          label: '加班天数(天)'
        }, {
          prop: 'dueSalary',
          label: '应发工资(元)'
        }, {
          prop: 'deduction',
          label: '加班工资(元)'
        }, {
          prop: 'realSalary',
          label: '实发工资(元)'
        }, {
          prop: 'date',
          label: '统计日期'
        }],
        tableData: [],
        total: 0,
        selectionArr: [],
        deptList: [],
        requestData: {
          deptCode: '',
          deptName: '',
          month: '',
          searchKey: '',
          pageSize: 10,
          pageNum: 1,
        },
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getAttendanceDeptList()
      this.getPage()
      this.getExpenseItem()
    },
    activated() {
      this.getAttendanceDeptList()
      this.getPage()
      this.getExpenseItem()
    },
    methods: {
      getAttendanceDeptList () {
        this.$axios.post(api.getAttendanceDeptList, {})
          .then(res => {
            let data = res.data.data || []
            data.map(v => {
              v.key = v.code
              v.label = v.deptName
            })
            data.unshift({
              key: '',
              label: '全部'
            })
            this.deptList = data
          })
          .catch(errorHandler('获取数据失败'))
      },
      beforeDownload () {
        this.exportUrl = `${api.exportAttendanceReport}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&month=${this.requestData.month}&deptCode=${this.requestData.deptCode}&deptName=${this.requestData.deptName}`
      },
      getPage () {
        this.deptList.map(v => {
          if (this.requestData.deptCode === v.code) {
            this.requestData.deptName = v.deptName
          }
        })
        if (!this.requestData.deptCode) {
          this.requestData.deptName = ''
        }
        this.$axios.post(api.getSalaryReportPage, this.requestData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {})
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      getExpenseItem () {
        if (this.requestData.month) {
          this.$axios.get(`${api.getExpenseItem}/${this.requestData.month}`)
            .then(res => {
              let data = res.data.data
              this.statisticalDataList.map(v => {
                v.num = data[v.code] || '0'
              })
            })
            .catch(errorHandler('获取数据失败'))
        }
      },
      search (v) {
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.requestData.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.requestData.pageNum = data[0]
        this.requestData.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      goToModifyPage (code) {
        this.$router.push({
          path: '/attendance_team_modify/' + code
        })
      },

      deleteLine (code) {
        this.$axios.post(api.deletePowerRoomByCodes, code)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('删除成功')
              this.selectionArr = []
              this.getPage()
            }
          })
          .catch(errorHandler('删除失败'))
      },

      // 生成报表
      manualGenerateReport () {
        if (!this.requestData.month) {
          nError('请先选择考勤月份')
          return false
        }
        this.$confirm('是否已完成考勤调整？报表生成后不可更改，是否继续？', "温馨提示", {
          type: "warning",
        })
          .then(() => {
            let date = `${this.requestData.month}-01`
            this.$axios.post(api.manualGenerateReport, {
              date: date
            })
              .then(res => {
                this.requestData.pageNum = 1
                this.requestData.pageSize = 10
                nSuccess('生成成功')
                this.getPage()
                this.getExpenseItem()
              })
              .catch(errorHandler('生成失败'))
          })
          .catch(() => {
            console.log("取消");
          });

      }
    },
    watch: {
      centEndTime(val) {
        this.getPage()
      },
      'requestData.month': {
        handler(newName, oldName) {
          this.getPage()
          this.getExpenseItem()
        },
        deep: true
      }
    }
  }
</script>

<style scoped lang="less">
.attendance-report-manage {
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
  .statistical-data-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .statistical-data-item {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      width: 308px;
      height: 87px;
      background: #FFFFFF;
      box-shadow: 0px 0px 8px rgba(92, 92, 92, 0.16);
      border-radius: 7px;
      .statistical-data-item-num {
        font-size: 27px;
        color: #1362FF;
      }
      .statistical-data-item-unit {
        font-size: 12px;
        color: #333333;
      }
      .statistical-data-item-tip {
        font-size: 13px;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceReport/AttendanceReportManage.vue